import React, {Component} from "react";
import Body from "./Body";
import Header from "./Header";
import Footer from "./Footer";
import ReactLoading from "react-loading";
import {VirtualHost} from "../../constants";

class Table extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paginationEnabled: true,
        };
        this.orderBy = this.orderBy.bind(this);
        this.pageSize = this.pageSize.bind(this);
        this.onShowSizeChange = this.onShowSizeChange.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onShowSizeChange(current, pageSize) {
        if (isNaN(pageSize)) {
            current = 1;
            pageSize = this.props.total;
        }
        this.pageSize(current - 1, pageSize);
    }

    onChange(current, pageSize) {
        this.pageSize(current - 1, pageSize);
    }

    componentWillMount() {
        if (this.props.paginationEnabled === undefined) {
            this.setState({paginationEnabled: true})
        } else {
            this.setState({paginationEnabled: this.props.paginationEnabled})
        }
        this.setState({page: this.props.page, size: this.props.size});

        if (!!this.props.fetchData  && !((["smart", "kolaysoft", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix)) && this.props.currentUser && (this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) {
            this.props.fetchData(undefined, undefined, this.props.page, this.props.size);
        }

    }

    orderBy(accessor, direction) {
        this.setState({accessor: accessor, direction: direction});
        if (!!this.props.fetchData) {
            this.props.fetchData(accessor, direction, this.state.page, this.state.size);
        }
        if (this.props.onSortChange) {
            this.props.onSortChange(accessor, direction);
        }
    }

    pageSize(page, size) {
        this.setState({page: page, size: size});
        if (!!this.props.fetchData)
            this.props.fetchData(this.state.accessor, this.state.direction, page, size);

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.manual === true && !!this.props.fetchData) {
            this.setState({page: nextProps.page, size: nextProps.size});
            this.props.fetchData(this.state.accessor, this.state.direction, nextProps.page, nextProps.size);
        }
    }

    render() {
        return (
            <table className={this.props.className} style={this.props.style}>
                <Header columns={this.props.columns} orderBy={this.orderBy}
                        total={this.props.total}
                        length={this.props.columns.length}
                        pageSize={this.pageSize}
                        options={this.props.options}
                        page={this.state.page}
                        size={this.state.size}
                        hide={this.state.paginationEnabled}
                        topPagination={this.props.topPagination}
                        />
                {this.props.loading
                    ? (<tbody>
                    <tr>
                        <td colSpan={this.props.columns.length}>{this.props.loadingText ? this.props.loadingText :
                            <ReactLoading type="spinningBubbles" style={{
                                width: "70px",
                                height: "70px",
                                margin: "20px auto 0 auto",
                                fill: "#888"
                            }}/>}</td>
                    </tr>
                    </tbody>)
                    : <Body columns={this.props.columns} items={this.props.content}
                            emptyMessage={this.props.emptyMessage || "Kayıt bulunamadı."}
                            getTrStyles={this.props.getTrStyles} getTrClass={this.props.getTrClass}/>
                }
                {this.state.paginationEnabled && <Footer total={this.props.total}
                                                         length={this.props.columns.length}
                                                         pageSize={this.pageSize}
                                                         options={this.props.options}
                                                         page={this.props.page}
                                                         size={this.state.size}
                                                         hide={this.state.paginationEnabled}
                                                         isJumberEnabled={this.props.jumberEnabled}
                                                         totalData={this.props.totalData}
                                                         content={this.props.content}
                                                         documentType={this.props.documentType}
                                                         tableType={this.props.tableType}
                                                         numberOfActiveCustomer={this.props.numberOfActiveCustomer}
                                                         numberOfPassiveCustomer={this.props.numberOfPassiveCustomer}
                                                         fetchDataUrl = {this.props.fetchDataUrl}
                                                         showTotalBtn={this.props.showTotalBtn}
                />}
            </table>
        );
    }
}

export default Table;